module.exports = __webpack_public_path__ + "static/assets/3e5189e4cd814b0d80c8ec6db1c31a4a.png";